import { createRoot } from 'react-dom/client';

// Import polyfills first
import './lib/polyfills.ts';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import App from './App.tsx';
import './index.css';

// Register service worker for PWA offline support
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .catch((err) => console.warn('SW registration failed:', err));
  });
}

// Fade out the inline splash screen once React is ready
function removeSplash() {
  const splash = document.getElementById('app-splash');
  if (!splash) return;
  splash.classList.add('fade-out');
  // Remove from DOM after fade completes
  setTimeout(() => splash.remove(), 500);
}

const root = createRoot(document.getElementById("root")!);
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);

// Remove splash after first render
requestAnimationFrame(() => {
  requestAnimationFrame(removeSplash);
});
